import { useNavigate } from "react-router-dom";
import { ArrowLeft, Bell, Footprints, X } from "lucide-react";
import styles from "./Header.module.css";
import logoH from "../assets/logo-blanco.png";
import { useNotifications } from "../notifications/NotificationsContext";

export default function Header() {
  const navigate = useNavigate();
  const { unreadCount } = useNotifications();

  return (
    <header className={styles.header}>
      <div className={styles.topbar}>
        <div className={styles.brandGroup}>
          {/* Botón de volver */}
          <button
            className={styles.backButton}
            onClick={() => navigate(-1)}
            aria-label="Volver"
          >
            <ArrowLeft size={22} />
          </button>

          {/* Logo a la derecha de la flecha */}
          <img
            src={logoH}
            alt="Human Center"
            className={styles.brandImg}
            loading="eager"
          />
        </div>

        <div className={styles.headerActions}>
          <button
            className={styles.moveButton}
            onClick={() => navigate("/move")}
            aria-label="Abrir Human Move"
          >
            <Footprints size={17} />
            <span>Move</span>
          </button>
          <button
            className={styles.notificationsButton}
            onClick={() => navigate("/notifications")}
            aria-label="Ver notificaciones"
          >
            <Bell size={22} />
            {unreadCount > 0 && (
              <span className={styles.notificationsBadge}>{unreadCount}</span>
            )}
          </button>
        </div>
      </div>
    </header>
  );
}


export function ModalHeader({ onBack }: { onBack: () => void }) {
  const navigate = useNavigate();
  const { unreadCount } = useNotifications();

  return (
    <header className={styles.header}>
      <div className={styles.topbar}>
        <div className={styles.brandGroup}>
          {/* Botón de volver */}
          <button
            className={styles.backButton}
            onClick={onBack}
            aria-label="Volver"
          >
             <X size={22} />
          </button>

          {/* Logo */}
          <img
            src={logoH}
            alt="Human Center"
            className={styles.brandImg}
            loading="eager"
          />
        </div>

        <div className={styles.headerActions}>
          <button
            className={styles.moveButton}
            onClick={() => navigate("/move")}
            aria-label="Abrir Human Move"
          >
            <Footprints size={17} />
            <span>Move</span>
          </button>
          <button
            className={styles.notificationsButton}
            onClick={() => navigate("/notifications")}
            aria-label="Ver notificaciones"
          >
            <Bell size={22} />
            {unreadCount > 0 && (
              <span className={styles.notificationsBadge}>{unreadCount}</span>
            )}
          </button>
        </div>
      </div>
    </header>
  );
}
